import Image from 'next/image';
import PropTypes from 'prop-types';

const BannerSection = ({ banner_image }) => {
  if (!banner_image?.url) return null;

  return (
    <div className="w-full relative">
      <div className="container mx-auto px-4">
        <Image
          src={banner_image.url}
          alt={banner_image.alt || banner_image.title}
          width={banner_image.width}
          height={banner_image.height}
          className="w-full h-auto rounded-lg"
          priority
        />
      </div>
    </div>
  );
};

BannerSection.propTypes = {
  banner_image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string,
    title: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
};

export default BannerSection;